<div class="dialog-header" mat-dialog-title>
  <div>
    <div class="eyebrow">Parts</div>
    <h2>{{ order?.id ? 'Edit Parts Order' : 'Create Parts Order' }}</h2>
  </div>
  <button mat-icon-button mat-dialog-close aria-label="Close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="dialog-body">
  <div class="grid">
    <mat-form-field appearance="outline">
      <mat-label>Title</mat-label>
      <input matInput [(ngModel)]="order.title" placeholder="e.g. Digikey mixed components">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Supplier</mat-label>
      <input matInput [(ngModel)]="order.supplier" placeholder="Digikey, Amazon, AliExpress">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Order Number</mat-label>
      <input matInput [(ngModel)]="order.orderNumber" placeholder="PO-12345">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Task Number</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="order.taskId" placeholder="e.g. 1042" (blur)="onTaskBlur()">
      <mat-hint class="task-hint" *ngIf="taskHint && !taskError">{{ taskHint }}</mat-hint>
      <mat-hint class="task-hint error" *ngIf="taskError">{{ taskError }}</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="order.status">
        <mat-option *ngFor="let status of statuses" [value]="status">
          {{ status | titlecase }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Unit Cost (cents)</mat-label>
      <input matInput type="number" min="0" [(ngModel)]="order.unitCostCents">
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notes</mat-label>
    <textarea matInput [(ngModel)]="order.notes" rows="3" placeholder="Additional context or links"></textarea>
  </mat-form-field>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-stroked-button color="primary" (click)="markReceived()" *ngIf="order.status !== 'received'">
    Mark received
  </button>
  <button mat-flat-button color="primary" (click)="save()">Save</button>
</div>
